// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { ContiNonRaccordatiDto, PianoContiDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class ContiNonRaccordatiApiClient extends BaseCRUDApiClient<ContiNonRaccordatiDto> {
  //baseUrl = this.config.apiEndpoint + '/conti-non-raccordati';
  baseUrl = this.config.apiEndpoint + '/piano-conti';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  override getAll() {
    this._pagedCache.clear();
    return this.http.get<PianoContiDto[]>(
      `${this.baseUrl}/piani-non-raccordati`
    );
  }
}
